<template>
   <v-container
    id="redeemInvite"
    class="fill-height justify-center"
    tag="section"
  >
    <v-overlay :value="busy">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-row justify="center">
      <shortcode-generator v-if="classLearner" action="joinClass" :title="$t('joinClass.title')" class="fixedwidth" :invite-code="$route.query.inviteCode">
        <p>{{ $t('joinClass.subtitle-with-organisation', [classLearner.class.organisation]) }}</p>
        <p v-html="$t('joinClass.instructions')" />
        <br>
        <p v-if="showUpdateWarning">
        <em>
          {{ $t('joinClass.version-warning') }}
        </em>
</p>
        <p><a target="_blank" :href="link">{{ $t('joinClass.help-link') }}</a></p>
      </shortcode-generator>

      <v-card v-if="!busy && !classLearner" class="fixedwidth">
        <v-card-title>Error!</v-card-title>
        <v-card-text>
          <p v-html="$t('joinClass.error-not-found')" />
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import 'firebase/auth'
  import api from '@/helpers/api.js'
  import shortcodeGenerator from '../components/ShortcodeGenerator.vue'

  export default {
    name: 'RedeemInvite',

    components: {
      'shortcode-generator': shortcodeGenerator,
    },

    data: () => ({
      busy: true,
      classLearner: undefined,
      coach: '',
    }),

    computed: {
      link () {
        return this.classLearner.class.instructionsURL ? this.classLearner.class.instructionsURL : 'https://coda.io/d/Bodyswaps-Help-Center_dbj9qpJWGoS/Joining-a-class_suqp1#_luxvR'
      },
      showUpdateWarning () {
        return Array.isArray(this.classLearner.class.content) && this.classLearner.class.content.length > 1
      },
    },

    async mounted () {
      this.busy = true
      this.classLearner = await api.getClassLearnerByInviteCode(this.$route.query.inviteCode)
      this.busy = false
    },

    methods: {
    },

  }
</script>

<style scoped>
.fixedwidth {
  max-width: 700px;
}
</style>
